'use client';

import { paletteEditorPopoverVisibleAtom } from '@/lib/atoms/general';
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from '@headlessui/react';
import { useAtom } from 'jotai';
import { Fragment, useMemo } from 'react';
import ToolbarMenu from '../other/ToolbarMenu';
import PaletteEditorComponent from './PaletteEditorComponent';
import useIsMobile from '@/lib/hooks/useIsMobile';
import { ToolbarMenuItemEnum } from '@/lib/types/general';

export interface PaletteListItem {
  id: string;
  name: string;
  colors: string[];
}

export interface PaletteEditorPopoverProps {
  onMenuClick: (menuItem: ToolbarMenuItemEnum) => void;
  onClosePopoverToolbar: () => void;
}

const PaletteEditorPopover = ({
  onMenuClick,
  onClosePopoverToolbar,
}: PaletteEditorPopoverProps) => {
  const isMobile = useIsMobile();
  const [paletteEditorPopoverVisible, setPaletteEditorPopoverVisible] = useAtom(
    paletteEditorPopoverVisibleAtom
  );

  const isVisible = useMemo(() => {
    return !isMobile && paletteEditorPopoverVisible;
  }, [paletteEditorPopoverVisible, isMobile]);

  const closePopover = () => {
    setPaletteEditorPopoverVisible(false);
  };

  return (
    <Popover className='relative flex flex-row items-center'>
      <PopoverButton className='w-full focus:outline-none'>
        <ToolbarMenu
          menuItem={ToolbarMenuItemEnum.Palettes}
          onClosePopoverToolbar={() => onClosePopoverToolbar?.()}
          onClick={() => onMenuClick(ToolbarMenuItemEnum.Palettes)}
          palettesIsVisible={isVisible}
        />
      </PopoverButton>

      <Transition
        as={Fragment}
        show={isVisible}
        enter='transition ease-out duration-200'
        enterFrom='opacity-0 translate-y-1'
        enterTo='opacity-100 translate-y-0'
        leave='transition ease-in duration-150'
        leaveFrom='opacity-100 translate-y-0'
        leaveTo='opacity-0 translate-y-1'
      >
        <PopoverPanel className='absolute top-12 z-10'>
          <PaletteEditorComponent onClose={closePopover} />
        </PopoverPanel>
      </Transition>
    </Popover>
  );
};

export default PaletteEditorPopover;
